import React from "react";
import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

// Clickable <th> that toggles asc/desc sort on a given column key.
// sortBy/sortDir/onSort are lifted to the parent so it can refetch with the new order.
export const SortableTh = ({ column, label, sortBy, sortDir, onSort, className = "" }) => {
  const isActive = sortBy === column;
  const Icon = isActive ? (sortDir === "asc" ? ChevronUp : ChevronDown) : ChevronsUpDown;

  return (
    <th className={className}>
      <button
        type="button"
        onClick={() => onSort(column)}
        className={`inline-flex items-center gap-1 font-medium transition-colors hover:text-ink-700 dark:hover:text-ink-200 ${
          isActive ? "text-ink-700 dark:text-ink-200" : ""
        }`}
      >
        {label}
        <Icon className="h-3 w-3" />
      </button>
    </th>
  );
};

// Small page-size dropdown, wired to a parent's pageSize state + fetch callback.
export const PageSizeSelect = ({ value, onChange, options = [10, 25, 50, 100], className = "" }) => (
  <label className={`inline-flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 whitespace-nowrap font-medium ${className}`}>
    <span>Rows per page</span>
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 px-2 py-1 text-xs font-semibold text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-1 focus:ring-brand-500 cursor-pointer"
    >
      {options.map((n) => (
        <option key={n} value={n}>
          {n}
        </option>
      ))}
    </select>
  </label>
);

// Toggles asc/desc on repeat click of the same column, defaults to asc on a new one.
export const nextSortDir = (sortBy, sortDir, column) =>
  sortBy === column ? (sortDir === "asc" ? "desc" : "asc") : "asc";
